const JobType = `
  id
  description
`;

export default JobType;
